<template>
  <div class="tw:my-24 tw:flex tw:items-center tw:justify-center tw:flex-col" v-if="staticMessageType !== 'none'">
    <Search class="tw:h-20 tw:w-20 tw:fill-gray-800" v-if="staticMessageType === 'welcome'" />
    <NoData class="tw:h-20 tw:w-20" v-if="staticMessageType === 'unauthorized'" />
    <NoResults class="tw:h-20 tw:w-20" v-if="staticMessageType === 'noResults'" />
    <GenericError class="tw:h-20 tw:w-20" v-if="staticMessageType === 'genericError'" />
    <p class="tw:max-w-xl tw:mt-12 tw:text-center tw:text-gray-800">{{ messages[staticMessageType].text }}</p>
  </div>
</template>

<script setup>
import Search from '@/components/icons/Search.svg?component'
import NoData from '@/components/icons/NoData.svg?component'
import NoResults from '@/components/icons/NoResults.svg?component'
import GenericError from '@/components/icons/GenericError.svg?component'

defineProps({
  staticMessageType: {
    type: String,
    default: 'none',
    validator(value) {
      return ['none', 'unauthorized', 'noResults', 'welcome', 'genericError'].includes(value)
    },
  },
})
const messages = {
  unauthorized: {
    text: "Only trivago eyes are allowed to see what's behind that search bar. Please log in with a trivago.com email to interact with this tool. Thanks!",
  },
  noResults: {
    text: 'No results found for this search. Please check your input and try again.',
  },
  welcome: {
    text: 'Welcome to the Admin tool. Search for an accommodation id to view information about the organization, users, and product ownerships, or search for an organisation by name or id to view and manage its users.',
  },
  genericError: {
    text: 'We are unable to process your request currently. If this message occurs again after a retry, please report to #independent-hotels-bugs',
  },
}
</script>
